import React from "react";

function Units() {
  return (
    <>
      {" μg/m"}
      <sup>3</sup>
    </>
  );
}

export default Units;
